import { CHEFS_FARM, GROWY } from "./CompanyConstants";

export const PRODUCT_IMAGE_CROP_SIZE = 570;
export const PRODUCT_IMAGE_MAX_WIDTH = 850;
export const PRODUCT_IMAGE_COMPRESSION_QUALITY = 0.7;
export const PRODUCT_IMAGE_ASPECT_RATIO = 1;
export const PRODUCT_PACKAGE_SIZES = ["small", "medium"];
export const PRODUCT_STOCK_COUNTRIES = [
  { code: "NL", label: "netherlands" },
  { code: "FR", label: "france" },
  { code: "DE", label: "germany" },
  { code: "BE", label: "belgium" },
  { code: "CH", label: "switzerland" },
];
export const PRODUCT_TRANSLATIONS_LANGUAGES = [
  { code: "en", label: "english" },
  { code: "nl", label: "dutch" },
  { code: "de", label: "german" },
  { code: "fr", label: "french" },
];

export const PRODUCT_MAIN_LANGUAGE = "en";
export const PRODUCT_COMPANY_GROUPS = [
  { label: "Growy", value: GROWY },
  { label: "Chef's Farm", value: CHEFS_FARM },
];

export const PRODUCT_GROUPS = [
  { label: "lettuce", value: "Lettuce" },
  { label: "herbs", value: "Herbs" },
  { label: "microgreens", value: "Microgreens" },
  { label: "flowers", value: "Flowers" },
  { label: "returnable_packaging", value: "Returnable packaging" },
  { label: "packaging", value: "Packaging" },
  { label: "other", value: "Other" },
  { label: "bundles", value: "Bundles" },
];
export const FARM_PRODUCT_GROUPS = ["Lettuce", "Herbs", "Microgreens", "Flowers"];
export const RETURNABLE_PACKAGING_PRODUCT_GROUP = "Returnable packaging";
export const MARKETING_CODES = [
  { label: "Supermarkets (SU)", value: "SU" },
  { label: "Wholesalers (WS)", value: "WS" },
  { label: "Horeca (CF)", value: "CF" },
];
